import { createStore, applyMiddleware } from 'redux';

import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import createSagaMiddleware from 'redux-saga';

import rootReducer from './root-reducer';
import rootSaga from './root-saga';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['downloads']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const sagasMiddleware = createSagaMiddleware();

const middlewares = [sagasMiddleware];

const store = createStore(persistedReducer, applyMiddleware(...middlewares));
const persistor = persistStore(store);

sagasMiddleware.run(rootSaga);

export { store, persistor };
